<template>
  <div>
    <div class="share-img" ref="canvasImg">
      <div class="qimg-sty">
        <img :src="img" alt />
        <van-overlay :show="showOverlay" @click="showOverlay = false">
          <div class="wrapper" @click.stop>
            <div class="wra-userInfo">
              <div>{{userData.username ? userData.username : userData.nickName}}</div>
              <div>{{userData.phone}}</div>
            </div>
            <div class="qr-img">
              <img :src="Qimg" alt v-if="code=='qrCode'" />
              <img :src="Simg" alt v-if="code=='shCode'" />
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
    <div>
      <!-- <van-button type="primary" @click="downloads()">下载图片</van-button> -->
    </div>
    <van-popup v-model="show" close-icon-position="top-left" @close='closeUp' closeable :overlay="false">
      <div>
        <div class="pop-title">长按图片保存</div>
        <img :src="imgUrl" alt class="cv-img" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/api";
import html2canvas from "html2canvas"
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      img: "",
      Qimg: "",
      Simg: '',
      imgUrl: '',
      isImg: false,
      show: false,
      code: '',
      showOverlay:true,
      userData:{},
    };
  },
  watch: {
    'userData': {
      handler: function () {
        this.downloads()
        // if (this.show == false) {
        //   this.isImg = false
        // }
        // if (this.show == true) {
        //   this.isImg = true
        // }
      }
    },
  },
  created(){
    this.img = localStorage.getItem("img");
    this.Qimg = localStorage.getItem("Qimg");
    this.Simg = localStorage.getItem("Simg");
    this.code = this.$route.query.code
    this.getUser()
  },
  mounted() {
   
  },
  methods: {
    closeUp(){
      this.$router.replace({path:'/showBusiness/details',query:{id:localStorage.getItem('productId')}})
    },
    getUser() {
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
        this.userData = res.data.data
      })
    },
    downloads() {
      let that = this;
      that.show = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true, // 禁止背景点击
        duration: 0 // 持续展示
      })
     if(that.img){
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
        var opts = {
        allowTaint: true,
        useCORS: true, // 【重要】开启跨域配置
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
        scrollX: 0,
        height: that.$refs.canvasImg.offsetHeight - 8,
        width: that.$refs.canvasImg.offsetWidth,
        scale: 8,
        dpi: window.devicePixelRatio * 4,
        backgroundColor: 'null',
      };
      setTimeout(() => {
        html2canvas(that.$refs.canvasImg, opts).then(res => {
          that.showOverlay=false
          let dataURL = res.toDataURL("image/jpeg");
          that.imgUrl = dataURL;
          Toast.clear()
          // that.savePost();
        });
      }, 500);
     }
    },
  },
};
</script>

<style scoped>
.van-overlay {
  position: absolute;
  width: 95%;
  height: 80px;
  top: auto;
  left: 50%;
  bottom: 15px;
  transform: translateX(-50%);
  border-radius: 10px;
  z-index: 1;
  background-color: rgba(0,0,0,.4);
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
}
.wra-userInfo{
  font-size: 20px;
  color: #FFF;
  line-height: 1.4;
}
.qr-img {
  width: 70px;
  height: 70px;
  position: relative;
}
.header-img-div , .header-img{
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 1.2px;
  background: #FFF;
}
.qimg-sty{
  position: relative;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.van-popup {
  width: 100%;
  height: 100%;
}
.share-img {
  width: 80%;
  position: relative;
  /* left: 50%;
  transform: translateX(-50%); */
}
.img-size {
  position: absolute;
  bottom: 20px;
  width: 150px;
  height: 150px;
  right: 10px;
}
img {
  width: 100%;
  /* height: 100%; */
}
.pop-title {
  font-size: 16px;
  text-align: center;
  padding: 19px;
}
.cv-img{
  width: 100%;
  /* display: block;
  margin: auto; */
}
</style>